import BulkExerciseCreator from './BulkExerciseCreator';

export default BulkExerciseCreator;
